import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.28 6.134a4.666 4.666 0 0 0-8.907 1.26 2.667 2.667 0 0 0-1.147 4.59c.49.433 1.12.618 1.774.617h3.333v-3.7l-.86.867a.67.67 0 1 1-.946-.947l2-2a.7.7 0 0 1 .22-.14.67.67 0 0 1 .506 0q.124.049.22.14l2 2a.666.666 0 0 1 0 .947.667.667 0 0 1-.946 0l-.86-.867v3.7h3.24a.7.7 0 0 0 .26 0c.701-.185 1.323-.648 1.771-1.219a3.333 3.333 0 0 0-1.658-5.248"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })